import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Constant from '@/configs/constant';
import * as helpers from '@/helpers';
import './plugins';
import vuetify from '@/plugins/vuetify';
import i18n from '@/locales/i18n';
import * as filters from './filters';
import '@/assets/css/global.css';
import '@fontsource/noto-sans-jp';
import '@fontsource/roboto';
import Vue2TouchEvents from 'vue2-touch-events';

Vue.use(Vue2TouchEvents);
Vue.config.productionTip = false;
Vue.prototype.$constant = Constant;
Vue.prototype.$helpers = helpers;
Vue.prototype.$fileUrl = process.env.VUE_APP_FILE_URL;
Object.keys(filters).forEach(key => { Vue.filter(key, filters[key]); });
new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
